import { css } from "@emotion/css";
import styled from "@emotion/styled";
import { Colors, Fonts } from "@snapchat/snap-design-system";

export const Title = styled.h2`
    ${Fonts.Heading.H300};
`;

export const dropdownStyle = css`
    width: 400px;

    .ant-select-selection-item {
        display: flex;
        gap: 8px;
        align-items: center;
    }
`;

export const ErrorMessage = styled.p`
    ${Fonts.Paragraph.P300};
    width: 400px;
    font-weight: 500;
    color: ${Colors.Red.V200};
    text-align: center;
`;

export const flexOptionstyles = css`
    .ant-select-item-option-content {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
`;
